<template>
  <div class="home">
    <h1>Welcome to the site!</h1>
    <p>
      <a href="https://www.healthline.com/health/cbt-techniques">Overview of CBT</a>
    </p>
    <p>
      <a href="https://www.therapistaid.com/therapy-guide/cognitive-restructuring">Cognitive Restructuring</a>
    </p>
    <p>
      <a href="https://www.psychologytools.com/self-help/thought-records/">Recording Thoughts</a>
    </p>
  </div>
</template>

<script>

export default {
  
}
</script>
